var map = {
	"./de/general7/slide2.svg": 694847,
	"./en/general7/slide2.svg": 771123,
	"./es/general7/slide2.svg": 704314,
	"./fr/general7/slide2.svg": 400786,
	"./nl/general7/slide2.svg": 216580,
	"./pt/general7/slide2.svg": 972630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 348371;